import React from "react";
import "../styles/FinalErrorModal.css"
import {useTheme} from '../providers/ThemeProvider';


interface FinalErrorModalProps {
    isOpen: boolean;
    onRetry: () => void;
    onExit: () => void;
    message?: string;
    canRetry?: boolean;
}

const FinalErrorModal: React.FC<FinalErrorModalProps> = ({
                                                             isOpen,
                                                             onRetry,
                                                             onExit,
                                                             message,
                                                             canRetry = true,
                                                         }) => {
    const {theme} = useTheme();
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="resume-modal content-error">
                <h2 className="modal-title-error"
                    dangerouslySetInnerHTML={{__html: theme?.content.finalErrorModal.title || ''}}></h2>

                <div className="modal-content">
                    {message ? (
                        <p className="modal-text-error">{message}</p>
                    ) : (
                        <>
                            <p className="modal-text-error">
                                {theme?.content.finalErrorModal.messagePart1_line1} <br className="mobile-break"/>
                                {theme?.content.finalErrorModal.messagePart1_line2}
                            </p>
                            <p className="modal-text-error">
                                {theme?.content.finalErrorModal.messagePart2_line1} <br className="mobile-break"/>
                                {theme?.content.finalErrorModal.messagePart2_line2}
                            </p>
                        </>
                    )}
                </div>

                <div className="modal-actions">
                    <button className="btn btn-secondary cancel-button" onClick={onExit}>
                        {theme?.content.finalErrorModal.cancelButton}
                    </button>
                    {canRetry && (
                        <button className="btn retry-button" onClick={onRetry}>
                            {theme?.content.finalErrorModal.retryButton}
                        </button>
                    )}
                </div>
            </div>

        </div>
    );
};

export default FinalErrorModal;
